/**
 * Created by calhosh on 7/16/2017.
 */

import {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {isEmpty, isEqual} from 'lodash';
import {isNullOrUndefined} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import {setFormV2ToasterVisibility} from '../../../actions/toastactions';
import ErrorsUtility from './index';

export default function Errors() {
	const errors = useSelector((store) => store.errors);
	const isModalOpen = useSelector((store) => store.isModalOpen);
	const errorMessage = useRef(null);
	const dispatch = useDispatch();

	const addNotification = (level, message, autoDismissInSeconds) => {
		!isModalOpen &&
			dispatch(
				setFormV2ToasterVisibility(
					true,
					level,
					Utility.createRichTextElement(!isNullOrUndefined(errorMessage.current) ? errorMessage.current : message),
					'',
					autoDismissInSeconds
				)
			);
	};

	useEffect(() => {
		if (!isEmpty(errors)) {
			if (!isEqual(errorMessage.current, errors.message)) {
				errorMessage.current = errorMessage.current !== null ? `${errorMessage.current}<br />${errors.message}` : errors.message;
			}
		} else {
			errorMessage.current = null;
		}
		ErrorsUtility.addNotification(errors, addNotification);
	}, [errors]);
}
